/**
 * Marca d'água das páginas de demonstração.
 *
 * Aparece na pré-visualização e sai impressa junto com a página: o conteúdo
 * fica legível, mas ninguém consegue usar o PDF sem que a marca apareça.
 */

interface Props {
  /** Texto da marcação. Vazio ou nulo desliga a marca d'água. */
  texto?: string | null;
  /** Linha menor, usada para identificar quem gerou o arquivo. */
  detalhe?: string | null;
}

const LINHAS = [-0.28, 0.02, 0.32];

export function MarcaDagua({ texto, detalhe }: Props) {
  const principal = texto?.trim();
  if (!principal) return null;

  return (
    <div
      aria-hidden
      style={{
        position: 'absolute',
        inset: 0,
        // Acima do conteúdo (1000) e abaixo de nada: é uma sobreposição.
        zIndex: 1200,
        pointerEvents: 'none',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-around',
        alignItems: 'center',
      }}
      className="marca-dagua"
    >
      {LINHAS.map((deslocamento, indice) => (
        <span
          key={indice}
          style={{
            display: 'block',
            transform: `rotate(-32deg) translateX(${deslocamento * 100}%)`,
            whiteSpace: 'nowrap',
            textAlign: 'center',
            lineHeight: 1.15,
            color: '#c0392b',
            opacity: 0.42,
          }}
        >
          <span
            style={{
              display: 'block',
              fontSize: '16pt',
              fontWeight: 800,
              letterSpacing: '0.14em',
              textTransform: 'uppercase',
              WebkitTextStroke: '0.35pt rgba(255,255,255,0.55)',
            }}
          >
            {principal}
          </span>
          {detalhe ? (
            <span
              style={{
                display: 'block',
                fontSize: '7.5pt',
                fontWeight: 600,
                letterSpacing: '0.22em',
                textTransform: 'uppercase',
                opacity: 0.9,
              }}
            >
              {detalhe}
            </span>
          ) : null}
        </span>
      ))}
    </div>
  );
}
